import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import React from 'react';

export const ConfirmationModal = ({
  isOpen,
  closeModal,
  primaryCTAAction,
  secondaryCTAAction,
  isLoading,
  isDisabled,
  userName,
}: {
  isOpen: boolean;
  closeModal: () => void;
  primaryCTAAction: () => void;
  secondaryCTAAction: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  userName: string;
}) => {
  return (
    <Modal isOpen={isOpen} onDismiss={closeModal}>
      <ModalHeader title="Allocate and Declare FBP" />
      <ModalBody>
        <Text weight="regular" size="medium">
          {`Confirm FBP allocation and declaration on behalf of ${userName} ?`}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" width="100%">
          <Button
            variant="tertiary"
            size="medium"
            isDisabled={isDisabled || isLoading}
            onClick={secondaryCTAAction}
            isFullWidth>
            Close
          </Button>

          <Button
            size="medium"
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={primaryCTAAction}
            isFullWidth>
            Confirm
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
